import axios from "axios";

interface LogDataParams {
  hotel: string;
  rsvnNo: string;
  progress: string;
  date: string;
  type: string;
  ref: string;
}

const baseURL = process.env.REACT_APP_H2O_BACKEND_BASEURL;
const apiKey = process.env.REACT_APP_H2O_API_KEY || "";

const request = axios.create({
  baseURL,
});

const headers = (header: Record<string, string | undefined>) => {
  return {
    headers: {
      "Content-Type": "application/json",
      "x-api-key": apiKey,
      ...(header && header),
    },
  };
};

export const logData = ({ hotel, rsvnNo, progress, date, type, ref }: LogDataParams) => {
  const data = { hotel, rsvnNo, progress, type, date, ref };
  return request.post("/h2o-ss/log", data, headers({}));
};
